import axios from "axios";
import router from "./router";
import { Message } from "element-ui";
// axios.defaults.baseURL = 'https://test-pc.kaidzs666.com/'

// 异常拦截处理器
const errorHandler = error => {
  setTimeout(() => {
    router.push("login");
  }, 1500);
  localStorage.removeItem("token");
  Message.error("请登录");
  return Promise.reject(error.data);
};

axios.interceptors.request.use(
  confing => {
    confing.headers.token = localStorage.getItem("token");
    return confing;
  },
  error => {
    return error;
  }
);

axios.interceptors.response.use(
  response => {
    if (response.data.code === 401) {
      return errorHandler(response);
    } else {
      return response;
    }
  },
  error => {
    return error;
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/axios.js